export const LANGUAGE_OPTIONS = [
  { code: "tr", flag: "tr", name: "Türkçe" }, { code: "en", flag: "gb", name: "English" }, { code: "ro", flag: "ro", name: "Română" }, { code: "fr", flag: "fr", name: "Français" }, { code: "ar", flag: "sa", name: "العربية" },
  { code: "de", flag: "de", name: "Deutsch" }, { code: "it", flag: "it", name: "Italiano" }, { code: "es", flag: "es", name: "Español" }, { code: "pt", flag: "pt", name: "Português" }, { code: "ru", flag: "ru", name: "Русский" }, { code: "az", flag: "az", name: "Azərbaycanca" }, { code: "fa", flag: "ir", name: "فارسی" }, { code: "zh", flag: "cn", name: "中文" },
];

export const SUPPORTED_LOCALES = LANGUAGE_OPTIONS.map((language) => language.code);

export const getLocaleFromPath = (pathname = "") => {
  const segment = pathname.split("/").filter(Boolean)[0];
  return SUPPORTED_LOCALES.includes(segment) ? segment : null;
};

export const getLocalizedPath = (pathname = "/", language = "tr") => {
  const parts = pathname.split("/").filter(Boolean);
  if (SUPPORTED_LOCALES.includes(parts[0])) parts.shift();
  const suffix = parts.length ? `/${parts.join("/")}` : "";
  return language === "tr" ? (suffix || "/") : `/${language}${suffix}`;
};

export const applyDocumentLanguage = (language) => {
  document.documentElement.lang = language;
  document.documentElement.dir = ["ar", "fa"].includes(language) ? "rtl" : "ltr";
};
